import { CockpitApplyDetailSection } from "./CockpitApplyDetailSection";
import { registerAppliesIntegrationSection } from "../integrationSections";

registerAppliesIntegrationSection("cockpit", CockpitApplyDetailSection);
